(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47810,19341,33030],{

/***/ 26033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Breadcrumbs/styles.module.scss
var styles_module = __webpack_require__(51701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/utils/useBreadcrumbs.js



/* harmony default export */ function useBreadcrumbs(param) {
    var className = param.className, _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, dark = param.dark;
    var classNames = classnames_default()((styles_module_default()).breadcrumbs, className, (0,_define_property/* default */.Z)({}, (styles_module_default()).dark, dark));
    return {
        className: classNames,
        breadcrumbs: breadcrumbs
    };
};

;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Breadcrumbs = function(props) {
    var ref = useBreadcrumbs(props), breadcrumbs = ref.breadcrumbs, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        "aria-label": "breadcrumbs",
        className: className,
        children: breadcrumbs.map(function(param, i) {
            var to = param.to, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50 * i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: to,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).activeItem, i === breadcrumbs.length - 1)),
                        children: title
                    })
                }))
            }, to);
        })
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().instanceOf(Array).isRequired,
    className: (prop_types_default()).string,
    dark: (prop_types_default()).bool
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 2610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26033);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42222);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);











var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var PageHeader = function(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, titleStyles = param.titleStyles, breadcrumbsStyles = param.breadcrumbsStyles, breadcrumbsTheme = param.breadcrumbsTheme, updatedAt = param.updatedAt, type = param.type, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                breadcrumbs: breadcrumbs,
                className: breadcrumbsStyles,
                type: type,
                dark: breadcrumbsTheme === "dark"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().titleContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleStyles, titleStyles), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                    children: [
                        updatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().updatedAt),
                            children: "Last updated: ".concat((0,utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p6)(updatedAt))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: title
                        }),
                        children
                    ]
                }))
            })
        ]
    });
};
PageHeader.defaultProps = {
    title: "",
    breadcrumbs: null,
    titleStyles: "",
    breadcrumbsStyles: ""
};
PageHeader.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbs: prop_types__WEBPACK_IMPORTED_MODULE_10___default().instanceOf(Array),
    titleStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbsStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 35745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./UI/components/Paginator/index.jsx + 1 modules
var Paginator = __webpack_require__(65300);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./components/BlogCommon/SelectionBlock/styles.module.scss
var styles_module = __webpack_require__(18195);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/SelectionBlock/index.jsx












var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var SelectionBlock = function(param) {
    var toggleFullscreenSearch = param.toggleFullscreenSearch;
    var isMobileCategoties = (0,es.useSelector)(layout/* selectIsMobileCategotiesOpened */.qL);
    (0,react.useEffect)(function() {
        (0,helper/* setOverflowForBody */.zd)(isMobileCategoties);
    }, [
        isMobileCategoties
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((styles_module_default()).selectionBlock, (0,_define_property/* default */.Z)({}, (styles_module_default()).showCategories, isMobileCategoties)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).buttons,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                type: constants/* SVG_IMAGES_TYPES.searchLg */.NL.searchLg,
                handleOnClick: toggleFullscreenSearch,
                className: (styles_module_default()).imgContainer
            })
        })
    });
};
SelectionBlock.defaultProps = {
    toggleFullscreenSearch: function() {
        return null;
    }
};
SelectionBlock.propTypes = {
    toggleFullscreenSearch: (prop_types_default()).func
};
/* harmony default export */ var BlogCommon_SelectionBlock = (SelectionBlock);

// EXTERNAL MODULE: ./components/BlogCommon/ArticlesList/index.jsx + 3 modules
var ArticlesList = __webpack_require__(63111);
// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 3 modules
var MetaTags = __webpack_require__(38067);
// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./components/Layout/FullLayout/index.jsx
var FullLayout = __webpack_require__(22116);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./components/Common/ModalWindow/index.jsx
var ModalWindow = __webpack_require__(79897);
// EXTERNAL MODULE: ./redux/apis/blog.js
var blog = __webpack_require__(9584);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/chunk.js
var chunk = __webpack_require__(8400);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
// EXTERNAL MODULE: ./components/Common/ButtonMore/index.jsx
var ButtonMore = __webpack_require__(52039);
// EXTERNAL MODULE: ./components/BlogCommon/FullscreenSearch/SearchResult/styles.module.scss
var SearchResult_styles_module = __webpack_require__(56546);
var SearchResult_styles_module_default = /*#__PURE__*/__webpack_require__.n(SearchResult_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/FullscreenSearch/SearchResult/index.jsx










var SearchResult = function(param) {
    var foundArticles = param.foundArticles, isFetching = param.isFetching, handleOnCloseModalWindow = param.handleOnCloseModalWindow;
    var ref = (0,react.useState)([]), articlesChunks = ref[0], setArticlesChunks = ref[1];
    var ref1 = (0,react.useState)([]), articles = ref1[0], setArticles = ref1[1];
    var handleOnButtonClick = function() {
        var shiftedChunks = (0,_to_consumable_array/* default */.Z)(articlesChunks);
        var chunk = shiftedChunks.shift();
        setArticlesChunks(shiftedChunks);
        setArticles(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat((0,_to_consumable_array/* default */.Z)(chunk));
        });
    };
    (0,react.useEffect)(function() {
        if (!foundArticles.length) {
            return;
        }
        var chunks = chunk_default()(foundArticles, 12);
        setArticlesChunks(chunks);
        setArticles(chunks.shift());
    }, [
        foundArticles
    ]);
    if (!articles.length && !isFetching) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (SearchResult_styles_module_default()).nothingFound,
            children: "Nothing Found. Please try again with some different keywords."
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchResult_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesList/* ArticlesList */.f, {
                articles: articles,
                handleOnCloseModalWindow: handleOnCloseModalWindow,
                isSearch: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore/* default */.Z, {
                title: "Load more",
                buttonStyle: classnames_default()((SearchResult_styles_module_default()).button, (0,_define_property/* default */.Z)({}, (SearchResult_styles_module_default()).hideButton, foundArticles.length === articles.length)),
                handleOnClick: handleOnButtonClick
            })
        ]
    });
};
SearchResult.propTypes = {
    foundArticles: prop_types_default().arrayOf(Object).isRequired,
    isFetching: (prop_types_default()).bool.isRequired,
    handleOnCloseModalWindow: (prop_types_default()).func.isRequired
};
/* harmony default export */ var FullscreenSearch_SearchResult = (SearchResult);

// EXTERNAL MODULE: ./components/BlogCommon/FullscreenSearch/styles.module.scss
var FullscreenSearch_styles_module = __webpack_require__(60588);
var FullscreenSearch_styles_module_default = /*#__PURE__*/__webpack_require__.n(FullscreenSearch_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/FullscreenSearch/index.jsx








var FullscreenSearch = function(param) {
    var isFullscreenSearch = param.isFullscreenSearch, closeFullscreenSearch = param.closeFullscreenSearch;
    var inputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), inputValue = ref[0], setInputValue = ref[1];
    var ref1 = (0,react.useState)(inputValue), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,blog/* useGetSearchResultQuery */.i1)(searchTerm), tmp = ref2.data, articles = tmp === void 0 ? [] : tmp, isFetching = ref2.isFetching;
    var delayedQuery = (0,react.useMemo)(function() {
        return debounce_default()(function(value) {
            return setSearchTerm(value);
        }, 1000);
    }, []);
    var handleOnChangeInput = function(param) {
        var value = param.target.value;
        setInputValue(value);
        delayedQuery(value);
    };
    var handleOnCloseModalWindow = function() {
        closeFullscreenSearch();
        setInputValue("");
        setSearchTerm("");
    };
    (0,react.useEffect)(function() {
        if (isFullscreenSearch && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, [
        isFullscreenSearch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWindow/* default */.Z, {
        isModalWindow: isFullscreenSearch,
        closeModalWindow: handleOnCloseModalWindow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FullscreenSearch_styles_module_default()).foundArticles,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    ref: inputRef,
                    className: (FullscreenSearch_styles_module_default()).input,
                    type: "text",
                    placeholder: "Type to search",
                    onChange: handleOnChangeInput,
                    value: inputValue
                }),
                searchTerm.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FullscreenSearch_SearchResult, {
                    foundArticles: articles,
                    isFetching: isFetching,
                    handleOnCloseModalWindow: handleOnCloseModalWindow
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (FullscreenSearch_styles_module_default()).nothingFound,
                    children: "Type some words to search."
                })
            ]
        })
    });
};
FullscreenSearch.defaultProps = {
    isFullscreenSearch: false
};
FullscreenSearch.propTypes = {
    isFullscreenSearch: (prop_types_default()).bool,
    closeFullscreenSearch: (prop_types_default()).func.isRequired
};
/* harmony default export */ var BlogCommon_FullscreenSearch = (/*#__PURE__*/(0,react.memo)(FullscreenSearch));

// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-outside-click-handler/index.js
var react_outside_click_handler = __webpack_require__(39834);
// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(3682);
// EXTERNAL MODULE: ./components/Common/AnimatedInput/styles.module.scss
var AnimatedInput_styles_module = __webpack_require__(37612);
var AnimatedInput_styles_module_default = /*#__PURE__*/__webpack_require__.n(AnimatedInput_styles_module);
;// CONCATENATED MODULE: ./components/Common/AnimatedInput/index.jsx












var AnimatedInput = function(param) {
    var value = param.value, handleOnChange = param.handleOnChange, placeholder = param.placeholder, type = param.type, handleOnBlurEmail = param.handleOnBlurEmail, isWithoutLabel = param.isWithoutLabel, isRequired = param.isRequired, isValidate = param.isValidate, isAttached = param.isAttached, isTextArea = param.isTextArea, style = param.style;
    var asPath = (0,router.useRouter)().asPath;
    var inputRef = (0,react.useRef)();
    var ref = (0,react.useState)(false), isInputActived = ref[0], setActive = ref[1];
    var ref1 = (0,react.useState)(false), isInputFocus = ref1[0], setFocus = ref1[1];
    var _obj;
    var animatedInput = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default())[style], style), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).animatedInput, true), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).isRequired, isRequired || isAttached), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).isValidate, !isValidate), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).active, isInputActived), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).focus, isInputFocus && isValidate), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default()).error, !isValidate && value !== ""), (0,_define_property/* default */.Z)(_obj, (AnimatedInput_styles_module_default())["default"], !isInputFocus && isValidate && value !== ""), _obj));
    var handleOnClick = function() {
        inputRef.current.focus();
        setActive(true);
    };
    var handleOnFocus = function() {
        setFocus(true);
    };
    var handleOnBlur = function() {
        setFocus(false);
        setActive(false);
        if (type === "email" && value !== "" && handleOnBlurEmail) {
            handleOnBlurEmail(value);
        }
    };
    var handleOnOutsideClick = function() {
        value === "" && setActive(false);
    };
    var inputOptions = {
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        ref: inputRef,
        placeholder: isWithoutLabel && placeholder,
        type: "text",
        id: value,
        value: value,
        onChange: handleOnChange,
        autoFocus: asPath === constants/* ROUTES.contact.path */.y2.contact.path && placeholder.includes("Name")
    };
    (0,react.useEffect)(function() {
        if (isTextArea && inputRef && inputRef.current) {
            (0,autosize_esm/* default */.Z)(inputRef.current);
        }
    }, [
        isTextArea
    ]);
    // the removing the textarea height when clearing form
    (0,react.useEffect)(function() {
        if (isTextArea && inputRef && inputRef.current && value === "") {
            if (inputRef.current.style.height !== "auto") {
                inputRef.current.style.height = "auto";
            }
        }
    }, [
        value,
        isTextArea
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_outside_click_handler["default"], {
        onOutsideClick: handleOnOutsideClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: animatedInput,
            onClick: handleOnClick,
            role: "textbox",
            tabIndex: "0",
            children: [
                !isWithoutLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                    htmlFor: value,
                    children: placeholder
                }),
                isTextArea ? /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputOptions), {
                    rows: 1
                })) : /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({}, inputOptions)),
                isRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (AnimatedInput_styles_module_default()).required,
                    children: "*"
                }),
                !isValidate && value !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (AnimatedInput_styles_module_default()).invalid,
                    children: "INVALID"
                })
            ]
        })
    });
};
AnimatedInput.defaultProps = {
    isWithoutLabel: false,
    handleOnBlurEmail: null,
    type: "",
    isRequired: false,
    isAttached: false,
    isTextArea: false,
    style: ""
};
AnimatedInput.propTypes = {
    value: (prop_types_default()).string.isRequired,
    handleOnChange: (prop_types_default()).func.isRequired,
    placeholder: (prop_types_default()).string.isRequired,
    isValidate: (prop_types_default()).bool.isRequired,
    type: (prop_types_default()).string,
    handleOnBlurEmail: (prop_types_default()).func,
    isWithoutLabel: (prop_types_default()).bool,
    isRequired: (prop_types_default()).bool,
    isAttached: (prop_types_default()).bool,
    isTextArea: (prop_types_default()).bool,
    style: (prop_types_default()).string
};
/* harmony default export */ var Common_AnimatedInput = (AnimatedInput);

// EXTERNAL MODULE: ./hocs/withValidateEmail.js
var withValidateEmail = __webpack_require__(54639);
// EXTERNAL MODULE: ./components/BlogCommon/FullscreenSubscribe/styles.module.scss
var FullscreenSubscribe_styles_module = __webpack_require__(47789);
var FullscreenSubscribe_styles_module_default = /*#__PURE__*/__webpack_require__.n(FullscreenSubscribe_styles_module);
;// CONCATENATED MODULE: ./components/BlogCommon/FullscreenSubscribe/index.jsx









var FullscreenSubscribe = function(param) {
    var isFullscreenSubscribe = param.isFullscreenSubscribe, closeFullscreenSubscribe = param.closeFullscreenSubscribe, email = param.email, handleOnEmailChange = param.handleOnEmailChange, handleOnBlurEmail = param.handleOnBlurEmail, handleOnSubmit = param.handleOnSubmit;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), _ = ref[0], ref1 = ref[1], tmp = ref1.data, ref2 = tmp === void 0 ? {} : tmp, message = ref2.message, newUser = ref2.newUser;
    var handleOnClick = function(event) {
        event.preventDefault();
        handleOnSubmit(email.value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWindow/* default */.Z, {
        isModalWindow: isFullscreenSubscribe,
        closeModalWindow: closeFullscreenSubscribe,
        className: (FullscreenSubscribe_styles_module_default()).fullscreenSubscribe,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (FullscreenSubscribe_styles_module_default()).subscribeBlock,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FullscreenSubscribe_styles_module_default()).subscribe,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (FullscreenSubscribe_styles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FullscreenSubscribe_styles_module_default()).title,
                            children: "Join for weekly insights"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FullscreenSubscribe_styles_module_default()).subtitle,
                            children: "Get weekly updates on the newest design stories, case studies and tips right in your mailbox."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FullscreenSubscribe_styles_module_default()).inputBlock,
                            children: [
                                newUser || /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_AnimatedInput, {
                                    value: email.value,
                                    handleOnChange: handleOnEmailChange,
                                    placeholder: "Email*",
                                    isWithoutLabel: true,
                                    type: "email",
                                    isValidate: email.isValidate,
                                    handleOnBlurEmail: handleOnBlurEmail
                                }),
                                message && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FullscreenSubscribe_styles_module_default()).alertMessage,
                                    children: message
                                }),
                                newUser || /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMore/* default */.Z, {
                                    title: "Subscribe",
                                    buttonStyle: (FullscreenSubscribe_styles_module_default()).button,
                                    handleOnClick: handleOnClick
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
FullscreenSubscribe.defaultProps = {
    isFullscreenSubscribe: false,
    handleOnSubmit: function() {}
};
FullscreenSubscribe.propTypes = {
    isFullscreenSubscribe: (prop_types_default()).bool,
    closeFullscreenSubscribe: (prop_types_default()).func.isRequired,
    email: prop_types_default().instanceOf(Object).isRequired,
    handleOnEmailChange: (prop_types_default()).func.isRequired,
    handleOnBlurEmail: (prop_types_default()).func.isRequired,
    handleOnSubmit: (prop_types_default()).func
};
/* harmony default export */ var BlogCommon_FullscreenSubscribe = ((0,withValidateEmail/* withValidateEmail */.l)(FullscreenSubscribe));

// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./hooks/useToggle.js
var useToggle = __webpack_require__(90981);
;// CONCATENATED MODULE: ./UI/views/Blog/utils/data.js
var categoriesMetaData = {
    "how-we-work": {
        metaTitle: "Tag: How we work | Yellow",
        metaDescription: "Read about our most successful projects. The Yellow team reveals its tips and tricks on their blog!",
        pageTitle: "How we work"
    },
    "software-development": {
        metaTitle: "Tag: Software Development | Yellow",
        metaDescription: "In this section, we bring you the latest software development news and insights. Don't miss reading!",
        pageTitle: "Software Development"
    },
    "software-chat": {
        metaTitle: "Tag: Software Chat | Yellow",
        metaDescription: "The Yellow team will reveal to you all the secrets of software chat development: detailed case studies, lists, guides.",
        pageTitle: "Software Chat"
    },
    fintech: {
        metaTitle: "Tag: Fintech | Yellow",
        metaDescription: "In this section, we will discuss the best practices of fintech development.\n    Lending platforms, trading services, e-wallets, budgeting apps, and more.",
        pageTitle: "Fintech"
    },
    yellow: {
        metaTitle: "Tag: Yellow  | Yellow Blog",
        metaDescription: "The latest news and achievements of the Yellow team. We share information about our company and its processes.",
        pageTitle: "Yellow"
    }
};

;// CONCATENATED MODULE: ./UI/views/Blog/utils/blogContainerHelper.js
var findTagBySlug = function(tagsList, slug) {
    return tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(tag) {
        return tag.slug === slug;
    });
};
var findCategoryBySlug = function(categories, slug) {
    return categories[slug];
};

// EXTERNAL MODULE: ./UI/views/Blog/BlogContainer.module.scss
var BlogContainer_module = __webpack_require__(3821);
var BlogContainer_module_default = /*#__PURE__*/__webpack_require__.n(BlogContainer_module);
;// CONCATENATED MODULE: ./UI/views/Blog/index.jsx






















var Blog_Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var BlogContainer = function(param) {
    var tagsList = param.tagsList, introSection = param.introSection, currentPage = param.currentPage, articlesNumberPerPage = param.articlesNumberPerPage, query = param.query;
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSubscribeMutation */.iD)({
        fixedCacheKey: dataSending/* SUBSCRIPTION_CASH_KEY */.X3
    }), 2), subscribe = ref[0], isLoading = ref[1].isLoading;
    var ref1 = (0,blog/* useGetBlogBundleQuery */.BZ)({
        pageSlug: constants/* PAGES.blog */.q5.blog,
        limit: query.limit,
        skip: query.skip,
        order: query.order || "[publishedAt_DESC]",
        isTag: query.isTag,
        slug: query.slug
    }), tmp = ref1.data, bundle = tmp === void 0 ? {} : tmp;
    var _articles = bundle.articles, articles = _articles === void 0 ? [] : _articles, tmp1 = bundle.total, totalArticles = tmp1 === void 0 ? 0 : tmp1, _page = bundle.page, _metaTitle = _page.metaTitle, metaTitle = _metaTitle === void 0 ? "" : _metaTitle, _metaDescription = _page.metaDescription, metaDescription = _metaDescription === void 0 ? "" : _metaDescription;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isFullscreenSearch = ref2[0], toggleFullscreenSearch = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), isFullscreenSubscribe = ref3[0], toggleFullscreenSubscribe = ref3[1];
    var ref4 = (0,router.useRouter)(), pathname = ref4.pathname, slug = ref4.query.slug;
    var tag = findTagBySlug(tagsList, slug);
    var category = findCategoryBySlug(categoriesMetaData, slug);
    var pagesCounter = Math.ceil(totalArticles / articlesNumberPerPage);
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(constants/* PAGES.blog */.q5.blog, {
        slug: slug,
        tagsList: tagsList
    });
    var pageMetadata = {
        metaTitle: metaTitle,
        metaDescription: metaDescription,
        url: "".concat(helper/* rootUrl */.Wd, "/").concat(constants/* PAGES.blog */.q5.blog),
        pageNumber: currentPage
    };
    if (tag || category) {
        pageMetadata.metaRobots = "noindex,follow";
    }
    var pageTitle = "";
    if (category) {
        var categoryMetaTitle = category.metaTitle, categoryMetaDescription = category.metaDescription, categoryTitle = category.pageTitle;
        pageMetadata.metaTitle = categoryMetaTitle;
        pageMetadata.metaDescription = categoryMetaDescription;
        pageTitle = categoryTitle;
    }
    if (tag) {
        var tagTitle = tag.title, tagDescription = tag.description;
        pageMetadata.metaTitle = "Tag: ".concat(tagTitle, " | Yellow");
        pageMetadata.metaDescription = tagDescription;
        pageTitle = tagTitle;
    }
    var handleOnFormSubmit = function(email) {
        if (isLoading) {
            return;
        }
        subscribe({
            email: email,
            pathname: pathname
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.blog */.q5.blog,
                pageMetadata: pageMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullLayout/* default */.Z, {
                introSection: introSection,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        title: pageTitle || constants/* ROUTES.blog.title */.y2.blog.title,
                        titleStyles: (BlogContainer_module_default()).title,
                        breadcrumbs: breadcrumbs,
                        breadcrumbsTheme: "dark",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_Svg, {
                            type: constants/* SVG_IMAGES_TYPES.searchLg */.NL.searchLg,
                            handleOnClick: toggleFullscreenSearch,
                            className: (BlogContainer_module_default()).searchButton
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCommon_SelectionBlock, {
                        toggleFullscreenSearch: toggleFullscreenSearch,
                        toggleFullscreenSubscribe: toggleFullscreenSubscribe
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlesList/* default */.Z, {
                        articles: articles,
                        isBlogPage: true,
                        currentPage: currentPage,
                        toggleFullscreenSubscribe: toggleFullscreenSubscribe
                    }),
                    !!pagesCounter && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginator/* default */.Z, {
                        pagesCounter: pagesCounter,
                        currentPage: currentPage,
                        pageSlug: constants/* ROUTES.blog.slug */.y2.blog.slug
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCommon_FullscreenSearch, {
                isFullscreenSearch: isFullscreenSearch,
                closeFullscreenSearch: toggleFullscreenSearch
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCommon_FullscreenSubscribe, {
                isFullscreenSubscribe: isFullscreenSubscribe,
                closeFullscreenSubscribe: toggleFullscreenSubscribe,
                handleOnSubmit: handleOnFormSubmit
            })
        ]
    });
};
BlogContainer.propTypes = {
    introSection: prop_types_default().instanceOf(Object).isRequired,
    currentPage: (prop_types_default()).number.isRequired,
    articlesNumberPerPage: (prop_types_default()).number.isRequired
};
/* harmony default export */ var Blog = (BlogContainer);


/***/ }),

/***/ 52039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40659);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48333);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var ButtonMore = function(_param) {
    var href = _param.href, dynamicRouting = _param.dynamicRouting, title = _param.title, buttonStyle = _param.buttonStyle, handleOnClick = _param.handleOnClick, buttonRef = _param.buttonRef, isDisabled = _param.isDisabled, disabledButtonStyle = _param.disabledButtonStyle, type = _param.type, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "href",
        "dynamicRouting",
        "title",
        "buttonStyle",
        "handleOnClick",
        "buttonRef",
        "isDisabled",
        "disabledButtonStyle",
        "type"
    ]);
    return !href.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: buttonRef,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonStyle, buttonStyle)),
        onClick: handleOnClick,
        role: "button",
        tabIndex: "0"
    }, rest), {
        children: title
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Common_LinkWrapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        isLocalLink: true,
        path: href,
        dynamicRouting: dynamicRouting,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().link), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[type], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, disabledButtonStyle, isDisabled))
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buttonStyle, buttonStyle)),
            onClick: handleOnClick,
            role: "button",
            tabIndex: "0",
            children: title
        })
    }));
};
ButtonMore.defaultProps = {
    href: "",
    dynamicRouting: "",
    buttonStyle: null,
    type: "",
    buttonRef: null,
    handleOnClick: null,
    isDisabled: false,
    disabledButtonStyle: null
};
ButtonMore.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    dynamicRouting: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
        prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object), 
    ]),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
    buttonStyle: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    handleOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func),
    buttonRef: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object),
    isDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),
    disabledButtonStyle: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonMore);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 38067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/microdata/data.js
var data = __webpack_require__(13107);
// EXTERNAL MODULE: ./utils/microdata/utils.js
var utils = __webpack_require__(20281);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./utils/microdata/deprecatedData.js




var _obj;
// TODO: Replace with actual data ASAP
var deprecatedData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareDevelopmentPrice.slug */.y2.softwareDevelopmentPrice.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Pricing: Hire a Team for Your Project | Yellow",
    description: "Calculate how much money you will need to build your software.\n    We only bill for the time actually spent on work, so it's easy to manage the budget. No extra fees.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.penetrationTesting.slug */.y2.penetrationTesting.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Penetration testing  | Yellow",
    description: "Use penetration testing to make sure your software solution is safe for your users. " + "Yellow will provide you with penetration testing services.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customMobileApp.slug */.y2.customMobileApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom mobile app development company | Yellow",
    description: "The best talents for Mobile App Development are here. Hire an experienced team to work on your idea.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.iosDevelopmentServices.slug */.y2.iosDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "iOS Mobile App Development Company | Yellow",
    description: "Yellow can provide you with iOS development services. If you want to create an iPhone or " + "iPad app, we are here to help.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.androidDevelopmentServices.slug */.y2.androidDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom Android App Development Company | Yellow",
    description: "Yellow is ready to provide you with Android development services to bring your idea to life.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.prototypingServices.slug */.y2.prototypingServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Mobile App Prototyping Services | Yellow",
    description: "Prototyping is an important stage in mobile app development. Complete it with Yellow!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customWebApp.slug */.y2.customWebApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Web Application Development Services | Yellow",
    description: "Our team is ready to provide you with web development services. " + "We are working with websites, PWAs, chatting applications, and landing pages.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareQualityAssuranceServices.slug */.y2.softwareQualityAssuranceServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Software Quality Assurance and Testing Services | Yellow",
    description: "Quality assurance is an important part of software product creation since it ensures that users" + " will receive a convenient and fully-functional solution. If you need QA services, Yellow is ready to provide them!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crowdfundingPlatform.slug */.y2.crowdfundingPlatform.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Crowdfunding Platform Development Company | Yellow",
    description: "Yellow is ready to provide you with crowdfunding platform development services. " + "High quality, realistic budget estimate, fast speed.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.fintechDevelopment.slug */.y2.fintechDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Fintech Software Development Services | Yellow",
    description: "The fintech industry is booming and doesn't seem to stop. Let's see how your " + "idea can take the slice of pie?",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.designServices.slug */.y2.designServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "UI/UX design services | Yellow",
    description: "Visual content matters, that is where UI/UX design comes into play.Users love good-looking " + "software. Make mobile your app or website captivating with Yellow.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.discoveryPhase.slug */.y2.discoveryPhase.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Project Discovery Phase in Custom Software Development | Yellow",
    description: "Discovery phase of a project is an important part of software development. " + "Learn more about how Yellow runs a discovery phase to benefit your business."
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.eWalletAppDevelopment.slug */.y2.eWalletAppDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "E-Wallet App Development Company | Yellow",
    description: "Mobile e-wallet app development services for any industry and any business scale.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.bankingSoftwareDevelopmentCompany.slug */.y2.bankingSoftwareDevelopmentCompany.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Banking Software Development Company | Yellow",
    description: "We provide companies and organizations big and small with outstanding banking software " + "development. Check out what we can do for you.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.deliveryQualityInYellow.slug */.y2.deliveryQualityInYellow.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "What Makes Yellow a Good Software Development Partner | Yellow",
    description: "Delivery quality standards we follow to build a perfect project for YOU.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.pwaDevelopmentServices.slug */.y2.pwaDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "PWA Development Services | Yellow",
    description: "Yellow is combining web and mobile worlds and creates progressive web " + "apps that function smoothly on all devices.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.paymentGatewayDevelopment.slug */.y2.paymentGatewayDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Payment Software Gateway Development Company | Yellow",
    description: "Yellow is a leading Payment Gateway Development company, providing customized " + "solutions to enhance transaction security and accuracy. Read more about our services now.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.billingSoftwareDevelopment.slug */.y2.billingSoftwareDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Billing Software Development Services Company | Yellow",
    description: "If you want to create brand-new billing software, partner with Yellow and build a top-tier solution.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crossPlatformDevelopmentServices.slug */.y2.crossPlatformDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Cross-Platform App Development Services | Yellow",
    description: "Your cross-platform application will rock the stage and Yellow is ready to make it happen.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.devOpsDevelopment.slug */.y2.devOpsDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "DevOps Development Company | Yellow",
    description: "If your company wants to integrate DevOps service into its processes and get all " + "the benefits this technology offers, Yellow is ready to lend a hand!",
    image: data/* logoUrl */.pt
}), _obj);

;// CONCATENATED MODULE: ./utils/microdata/index.js






function getPageMicrodata(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, breadcrumbs = ref.breadcrumbs, microData = ref.microData;
    var microdataArray = [
        // TODO: uncomment when deprecated data will be replaced
        // webpageMicrodata,
        data/* websiteMicrodata */.IR,
        data/* organisationMicrodata */.nW, 
    ];
    var breadcrumbsMicrodata = (0,utils/* getBreadcrumbsMicrodata */.js)(breadcrumbs);
    if (breadcrumbsMicrodata) {
        microdataArray.push(breadcrumbsMicrodata);
    }
    switch(page){
        case constants/* ROUTES.homepage.slug */.y2.homepage.slug:
        case constants/* ROUTES.contact.slug */.y2.contact.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            break;
        case constants/* ROUTES.company.slug */.y2.company.slug:
        case constants/* ROUTES.whyUs.slug */.y2.whyUs.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            microdataArray.push(data/* aboutPageMicrodata */.WN);
            break;
        case constants/* ROUTES.blog.slug */.y2.blog.slug:
        case constants/* ROUTES.portfolio.slug */.y2.portfolio.slug:
        case constants/* ROUTES.project.slug */.y2.project.slug:
        case constants/* ROUTES.process.slug */.y2.process.slug:
        case constants/* ROUTES.termsAndConditions.slug */.y2.termsAndConditions.slug:
        case constants/* ROUTES.cookiesPolicy.slug */.y2.cookiesPolicy.slug:
        case constants/* ROUTES.privacyPolicy.slug */.y2.privacyPolicy.slug:
            break;
        case constants/* ROUTES.article.slug */.y2.article.slug:
            microdataArray.push((0,utils/* getArticleMicrodata */.WK)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, microData), {
                organisationMicrodata: data/* organisationMicrodata */.nW
            })));
            break;
        case constants/* ROUTES.person.slug */.y2.person.slug:
            microdataArray.push((0,utils/* getPersonMicrodata */.RK)(microData));
            break;
        default:
            var currentRoute = Object.values(constants/* ROUTES */.y2).find(function(route) {
                return route.slug === page;
            });
            var oldData = deprecatedData[page];
            if (oldData) {
                microdataArray.push(oldData);
                break;
            }
            microdataArray.push((0,utils/* getServiceMicrodata */.fi)(currentRoute, {
                organisationMicrodata: data/* organisationMicrodata */.nW,
                category: data/* CATEGORY */.En[page],
                offers: data/* OFFERS */.jn[page],
                addresses: data/* addresses */.UB
            }));
            break;
    }
    return microdataArray;
}

;// CONCATENATED MODULE: ./components/Common/MetaTags/utils/data.js
var defaultMetadata = {
    title: "Trusted AI Transformation Agency | Yellow",
    description: "We help businesses turn their AI initiatives into production-grade solutions with measurable results."
};

;// CONCATENATED MODULE: ./components/Common/MetaTags/index.jsx
/* eslint-disable react/jsx-max-props-per-line */ 






var MetaTags = function(param) {
    var page = param.page, pageMetadata = param.pageMetadata, children = param.children, breadcrumbs = param.breadcrumbs, microData = param.microData, isArticle = param.isArticle;
    var metaTitle = pageMetadata.metaTitle, metaDescription = pageMetadata.metaDescription, metaRobots = pageMetadata.metaRobots, image = pageMetadata.image, publishedAt = pageMetadata.publishedAt, categoryTag = pageMetadata.categoryTag, keyWords = pageMetadata.keyWords, pageNumber = pageMetadata.pageNumber, url = pageMetadata.url, ogImage = pageMetadata.ogImage;
    var microdata = getPageMicrodata(page, {
        breadcrumbs: breadcrumbs,
        microData: microData
    });
    var getTitle = function() {
        return pageNumber > 1 ? "".concat(metaTitle || defaultMetadata.title, " | Page ").concat(pageNumber) : metaTitle || defaultMetadata.title;
    };
    var getDescription = function() {
        return pageNumber > 1 ? "".concat(metaDescription || defaultMetadata.description, " | Page ").concat(pageNumber) : metaDescription || defaultMetadata.description;
    };
    var getImage = function() {
        if (ogImage) return ogImage;
        if (isArticle) return image;
        return (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png");
    };
    var date = isArticle ? publishedAt : new Date();
    var type = isArticle ? "article" : "website";
    var title = getTitle();
    var description = getDescription();
    var robots = !constants/* IS_PROD */.XK ? "none" : metaRobots;
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "date",
                content: date
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: getImage()
            }),
            categoryTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:section",
                content: categoryTag
            }),
            publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:published_time",
                content: publishedAt
            }),
            keyWords === null || keyWords === void 0 ? void 0 : keyWords.map(function(keyWord) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "article:tag",
                    content: keyWord
                }, "meta/tag/".concat(keyWord));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: (0,helper/* getPathWithCdn */.d6)("/yellow_logo.ico")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: (0,helper/* getPathWithCdn */.d6)("/safari-pinned-tab.svg"),
                color: "#ffbf02"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "application/ld+json/microdata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(microdata, null, 2)
                }
            })
        ]
    }));
};
MetaTags.defaultProps = {
    children: null,
    pageMetadata: {},
    articleData: {},
    breadcrumbs: [],
    isArticle: false
};
MetaTags.propTypes = {
    page: (prop_types_default()).string.isRequired,
    breadcrumbs: prop_types_default().instanceOf(Array),
    articleData: prop_types_default().instanceOf(Object),
    pageMetadata: prop_types_default().shape({
        metaTitle: (prop_types_default()).string,
        metaDescription: (prop_types_default()).string,
        metaRobots: (prop_types_default()).string,
        image: (prop_types_default()).string,
        ogImage: (prop_types_default()).string,
        publishedAt: (prop_types_default()).string,
        categoryTag: (prop_types_default()).string,
        keyWords: prop_types_default().instanceOf(Array),
        pageNumber: (prop_types_default()).number
    }),
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array,
        (prop_types_default()).element, 
    ]),
    isArticle: (prop_types_default()).bool,
    defaultMetaData: prop_types_default().instanceOf(Array)
};
/* harmony default export */ var Common_MetaTags = (MetaTags);


/***/ }),

/***/ 79897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86324);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);









var Svg = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var ModalWindow = function(param) {
    var isModalWindow = param.isModalWindow, closeModalWindow = param.closeModalWindow, children = param.children, className = param.className;
    var modalRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var handleOnClick = function(param) {
        var target = param.target;
        if (modalRef && modalRef.current) {
            if (modalRef.current.isEqualNode(target)) closeModalWindow();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,utils_helper__WEBPACK_IMPORTED_MODULE_4__/* .setOverflowForBody */ .zd)(isModalWindow);
    }, [
        isModalWindow
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleOnKeyDown = function(param) {
            var key = param.key;
            if (key === "Escape") {
                closeModalWindow();
            }
        };
        document.addEventListener("keydown", handleOnKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleOnKeyDown);
        };
    }, [
        closeModalWindow
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindowContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().show), isModalWindow)),
        onClick: handleOnClick,
        ref: modalRef,
        role: "dialog",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalWindow), className),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Svg, {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().svg),
                    type: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SVG_IMAGES_TYPES.closeSvg */ .NL.closeSvg,
                    handleOnClick: closeModalWindow
                }),
                children
            ]
        })
    });
};
ModalWindow.defaultProps = {
    className: ""
};
ModalWindow.propTypes = {
    isModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool.isRequired),
    closeModalWindow: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func.isRequired),
    children: prop_types__WEBPACK_IMPORTED_MODULE_8___default().instanceOf(Object).isRequired,
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalWindow);


/***/ }),

/***/ 22116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(321);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);





var FullLayout = function(param) {
    var children = param.children, disableMaxWidth = param.disableMaxWidth, disableTopPadding = param.disableTopPadding, disableSidePadding = param.disableSidePadding, disableBottomPadding = param.disableBottomPadding, disableOverflowHiding = param.disableOverflowHiding, backgroundColor = param.backgroundColor, introSection = param.introSection, className = param.className;
    var _obj;
    var layoutStyles = classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().fullLayout), (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[backgroundColor], (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableMaxWidth), disableMaxWidth), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableTopPadding), disableTopPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableSidePadding), disableSidePadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableBottomPadding), disableBottomPadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disableOverflowHiding), disableOverflowHiding), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: layoutStyles,
        ref: introSection,
        children: children
    });
};
FullLayout.defaultProps = {
    children: {},
    disableMaxWidth: false,
    disableTopPadding: false,
    disableSidePadding: false,
    disableBottomPadding: false,
    backgroundColor: "",
    introSection: null
};
FullLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object),
    disableMaxWidth: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableTopPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableSidePadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    disableBottomPadding: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    introSection: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object)
};
/* harmony default export */ __webpack_exports__["Z"] = (FullLayout);


/***/ }),

/***/ 54639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ withValidateEmail; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6572);




var withValidateEmail = function(Component) {
    return function(props) {
        var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
            value: "",
            isValidate: true
        }), email = ref[0], setEmail = ref[1];
        var handleOnEmailChange = function(param) {
            var value = param.target.value;
            setEmail({
                value: value,
                isValidate: true
            });
        };
        var handleOnBlurEmail = function(value) {
            setEmail({
                value: value,
                isValidate: (0,utils_helper__WEBPACK_IMPORTED_MODULE_2__/* .validateEmail */ .oH)(value)
            });
        };
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            email: email,
            handleOnEmailChange: handleOnEmailChange,
            handleOnBlurEmail: handleOnBlurEmail
        }, props));
    };
};


/***/ }),

/***/ 90981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var reducer = function(stateHandler) {
    return function(state) {
        if (typeof stateHandler === "function") {
            stateHandler(!state);
        }
        return !state;
    };
};
function useToggle(initialState, stateHandler) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(reducer(stateHandler), !!initialState), isEnabled = ref[0], toggle = ref[1];
    return [
        isEnabled,
        toggle
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useToggle);


/***/ }),

/***/ 9584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$D": function() { return /* binding */ useGetArticlesRelatedToPersonQuery; },
/* harmony export */   "BZ": function() { return /* binding */ useGetBlogBundleQuery; },
/* harmony export */   "M9": function() { return /* binding */ useGetDraftArticleQuery; },
/* harmony export */   "i1": function() { return /* binding */ useGetSearchResultQuery; },
/* harmony export */   "nB": function() { return /* binding */ useGetArticleQuery; }
/* harmony export */ });
/* unused harmony exports useGetArticlesListQuery, useGetTagsQuery, useGetRelatedArticlesQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87185);
/* harmony import */ var lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24376);
/* harmony import */ var utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91217);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65686);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96076);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93250);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91555);












var blogApi = ___WEBPACK_IMPORTED_MODULE_1__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            getBlogBundle: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                query: function query(param) {
                    var pageSlug = param.pageSlug, limit = param.limit, skip = param.skip, _order = param.order, order = _order === void 0 ? "[publishedAt_DESC]" : _order, _isTag = param.isTag, isTag = _isTag === void 0 ? false : _isTag, slug = param.slug;
                    return utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadBlogBundle */ .f.loadBlogBundle({
                        pageSlug: pageSlug,
                        limit: limit,
                        skip: skip,
                        order: order,
                        isTag: isTag,
                        slug: slug
                    });
                },
                transformResponse: function transformResponse(response, _, param) {
                    var isTag = param.isTag;
                    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
                    var tags = (response === null || response === void 0 ? void 0 : (ref = response.tags) === null || ref === void 0 ? void 0 : ref.items) || [];
                    var page = (response === null || response === void 0 ? void 0 : (ref1 = response.page) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2[0]) || {};
                    var articles = isTag ? (response === null || response === void 0 ? void 0 : (ref3 = response.articlesByTag) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.linkedFrom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.articleCollection) === null || ref7 === void 0 ? void 0 : ref7.items) || [] : (response === null || response === void 0 ? void 0 : (ref8 = response.articles) === null || ref8 === void 0 ? void 0 : ref8.items) || [];
                    var total = isTag ? (response === null || response === void 0 ? void 0 : (ref9 = response.articlesByTag) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.linkedFrom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.articleCollection) === null || ref13 === void 0 ? void 0 : ref13.total) || 0 : (response === null || response === void 0 ? void 0 : (ref14 = response.articles) === null || ref14 === void 0 ? void 0 : ref14.total) || 0;
                    return {
                        tags: tags,
                        page: page,
                        articles: articles,
                        total: total
                    };
                }
            }),
            getArticlesList: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                query: function query(param) {
                    var slug = param.slug, skip = param.skip, limit = param.limit, _isTag = param.isTag, isTag = _isTag === void 0 ? false : _isTag, _order = param.order, order = _order === void 0 ? "[publishedAt_DESC]" : _order;
                    return isTag ? utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticlesByTags */ .f.loadPreviewArticlesByTags({
                        limit: limit,
                        skip: skip,
                        order: order,
                        where: {
                            slug: slug
                        }
                    }) : utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticles */ .f.loadPreviewArticles({
                        skip: skip,
                        limit: limit,
                        order: order
                    });
                },
                transformResponse: function transformResponse(response, _, param) {
                    var isTag = param.isTag;
                    return {
                        items: isTag ? (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticlesByTags */ .nd)(response) : (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticles */ .fH)(response),
                        total: isTag ? (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultTotalArticlesCountByTags */ .g3)(response) : (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultTotalArticlesCount */ .QX)(response)
                    };
                }
            }),
            getArticlesRelatedToPerson: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.getEntries
                },
                query: function query(param) {
                    var id = param.id, skip = param.skip, limit = param.limit;
                    return {
                        contentType: "article",
                        additionalQueryParams: {
                            links_to_entry: id,
                            order: "-fields.publishedAt",
                            skip: skip,
                            limit: limit
                        }
                    };
                },
                transformResponse: function transformResponse(response) {
                    return {
                        items: response.items,
                        total: response.total
                    };
                }
            }),
            getTags: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                query: function query() {
                    return utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadTag */ .f.loadTag({});
                },
                transformResponse: function transformResponse(response) {
                    return (0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultTags */ .u6)(response);
                }
            }),
            getArticle: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.getEntries
                },
                queryFn: function queryFn(param, _, __, baseQuery) {
                    var slug = param.slug;
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                        var ref, ref1, ref2, article, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]);
                                    if (!slug) {
                                        return [
                                            2,
                                            {
                                                error: "Wrong argument"
                                            }
                                        ];
                                    }
                                    return [
                                        4,
                                        baseQuery({
                                            contentType: "article",
                                            query: {
                                                slug: slug
                                            }
                                        })
                                    ];
                                case 1:
                                    article = (ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.items) === null || ref2 === void 0 ? void 0 : ref2[0];
                                    // const {
                                    //   publishedAt,
                                    //   tagsList,
                                    // } = getDocumentFields(article, ['tagsList', 'publishedAt']);
                                    // const [nextPrev, related] = await Promise.all([
                                    //   // blogClient.graphql(GRAPHQL_QUERY.getNearbyArticle({
                                    //   //   limit: 2,
                                    //   //   // order: '[publishedAt_DESC]',
                                    //   //   where: { publishedAt_lt: publishedAt },
                                    //   // })),
                                    //   // blogClient.graphql(GRAPHQL_QUERY.getNearbyArticle({
                                    //   //   limit: 1,
                                    //   //   order: '[publishedAt_DESC]',
                                    //   //   where: { publishedAt_gt: publishedAt },
                                    //   // })),
                                    //   blogClient.graphql(GRAPHQL_QUERY.getRelatedArticles({
                                    //     limit: 10,
                                    //     where: { slug: tagsList[0].fields.slug },
                                    //   })),
                                    // ]);
                                    return [
                                        2,
                                        {
                                            data: {
                                                article: article
                                            }
                                        }
                                    ];
                                case 2:
                                    e = _state.sent();
                                    console.log(e, "-------------");
                                    return [
                                        3,
                                        3
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                },
                keepUnusedDataFor: 120
            }),
            getDraftArticle: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogPreviewClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.getEntries
                },
                query: function query(slug) {
                    return {
                        contentType: "article",
                        query: {
                            slug: slug
                        }
                    };
                },
                transformResponse: function transformResponse(response) {
                    return response.items[0];
                }
            }),
            getSearchResult: builder.query({
                extraOptions: {
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_2__.blogClient,
                    type: ___WEBPACK_IMPORTED_MODULE_1__.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
                        var ref, byTagRaw, byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        Promise.all([
                                            baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticlesByTags */ .f.loadPreviewArticlesByTags({
                                                where: {
                                                    title_contains: value
                                                },
                                                limit: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SEARCH_ARTICLES_LIMIT */ .WV
                                            })),
                                            baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_3__/* .GRAPHQL_QUERY.loadPreviewArticles */ .f.loadPreviewArticles({
                                                order: "[publishedAt_DESC]",
                                                limit: utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                                where: {
                                                    OR: [
                                                        {
                                                            title_contains: value
                                                        },
                                                        {
                                                            oldBody_contains: value
                                                        },
                                                        {
                                                            title_contains: value
                                                        }
                                                    ]
                                                }
                                            }))
                                        ])
                                    ];
                                case 2:
                                    ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"].apply */ .Z.apply(void 0, [
                                        _state.sent(),
                                        2
                                    ]), byTagRaw = ref[0], byText = ref[1];
                                    result = lodash_uniqWith__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticlesByTags */ .nd)(byTagRaw.data)).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_4__/* .getGraphqlResultArticles */ .fH)(byText.data))), function(article1, article2) {
                                        return article1.slug === article2.slug;
                                    }).sort(function(a, b) {
                                        return Date.parse(a) - Date.parse(b);
                                    });
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_10__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useGetBlogBundleQuery = blogApi.useGetBlogBundleQuery, useGetArticlesListQuery = blogApi.useGetArticlesListQuery, useGetTagsQuery = blogApi.useGetTagsQuery, useGetArticleQuery = blogApi.useGetArticleQuery, useGetSearchResultQuery = blogApi.useGetSearchResultQuery, useGetDraftArticleQuery = blogApi.useGetDraftArticleQuery, useGetRelatedArticlesQuery = blogApi.useGetRelatedArticlesQuery, useGetArticlesRelatedToPersonQuery = blogApi.useGetArticlesRelatedToPersonQuery;
/* harmony default export */ __webpack_exports__["ZP"] = (blogApi);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);


function getBreadcrumbs(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, title = ref.title, slug = ref.slug, tagsList = ref.tagsList;
    var currentRoute = Object.values(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES */ .y2).find(function(route) {
        return route.slug === page;
    });
    var breadcrumbs = [
        {
            to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.path */ .y2.homepage.path,
            title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.title */ .y2.homepage.title
        }, 
    ];
    switch(currentRoute.slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.slug */ .y2.blog.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (slug && !(0,utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .kE)(slug)) {
                var tag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(param) {
                    var tagSlug = param.slug;
                    return tagSlug === slug;
                });
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                    title: tag === null || tag === void 0 ? void 0 : tag.title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.slug */ .y2.project.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.path */ .y2.portfolio.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.breadcrumpsTitle */ .y2.portfolio.breadcrumpsTitle
            });
            if (title && slug) {
                var cleanTitle = (title === null || title === void 0 ? void 0 : title.replace(/\s*\[Case Study\].*$/, "").trim()) || "";
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.getRoute */ .y2.project.getRoute(slug).path,
                    title: cleanTitle
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.slug */ .y2.article.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.getRoute */ .y2.article.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.slug */ .y2.person.slug:
            breadcrumbs.splice(0, 1);
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.getRoute */ .y2.person.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        default:
            breadcrumbs.push({
                to: currentRoute.path,
                title: currentRoute.title
            });
            return breadcrumbs;
    }
}


/***/ }),

/***/ 51701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__U7jAD","item":"styles_item__WAV19","activeItem":"styles_activeItem__Sdvlz","dark":"styles_dark__9MzT_"};

/***/ }),

/***/ 42222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__EQ1kE","updatedAt":"styles_updatedAt__pww8i"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 3821:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogContainer_title__pSut_","searchButton":"BlogContainer_searchButton__lFuev"};

/***/ }),

/***/ 56546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nothingFound":"styles_nothingFound__Koocr","container":"styles_container__qh8Eo","button":"styles_button__Ji1Q_","hideButton":"styles_hideButton__bRxX5"};

/***/ }),

/***/ 60588:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"foundArticles":"styles_foundArticles__m4XQE","input":"styles_input__LAuLb","nothingFound":"styles_nothingFound__pzrQ_"};

/***/ }),

/***/ 47789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullscreenSubscribe":"styles_fullscreenSubscribe__W1acR","subscribeBlock":"styles_subscribeBlock__Rjrio","subscribe":"styles_subscribe__hgcUO","content":"styles_content__ICcI5","title":"styles_title__WY2C_","subtitle":"styles_subtitle__xrXGI","inputBlock":"styles_inputBlock__1Ravz","button":"styles_button__UHEFO"};

/***/ }),

/***/ 18195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectionBlock":"styles_selectionBlock__z9Pya","buttons":"styles_buttons__JgV5H","imgContainer":"styles_imgContainer__RLohM","showCategories":"styles_showCategories__3kAgr"};

/***/ }),

/***/ 37612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animatedInput":"styles_animatedInput__dkzWe","required":"styles_required__niI4c","invalid":"styles_invalid__3htvm","active":"styles_active__3ODrq","focus":"styles_focus__pqxmp","error":"styles_error__DObs8","default":"styles_default__H1PCb","isRequired":"styles_isRequired__c4zue","isValidate":"styles_isValidate__fMuzW","seven-pm-thursday":"styles_seven-pm-thursday__sa0JX","open-sense":"styles_open-sense__UAjOY"};

/***/ }),

/***/ 48333:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__copVk","home":"styles_home__QWxgR"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ }),

/***/ 86324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalWindowContainer":"styles_modalWindowContainer__ob2Fw","modalWindow":"styles_modalWindow__y6P7Y","svg":"styles_svg__i9wAY","show":"styles_show__3kdTG"};

/***/ }),

/***/ 321:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fullLayout":"styles_fullLayout__pin3O","disableOverflowHiding":"styles_disableOverflowHiding__LcGJo","disableMaxWidth":"styles_disableMaxWidth__V_d1K","disableSidePadding":"styles_disableSidePadding__Ybgq_","disableTopPadding":"styles_disableTopPadding__PX_CS","disableBottomPadding":"styles_disableBottomPadding__8xmaX","alabaster":"styles_alabaster__keXtu"};

/***/ })

}]);